import React, { lazy } from 'react';
import { Eye, CheckCircle, MessageCircle, Gift } from 'lucide-react';
// WhatsApp number - replace with actual number
const WHATSAPP_NUMBER = '[NÚMERO_WHATSAPP]';
// Gift card image - replace with your image URL
const GIFT_IMAGE_URL = 'https://via.placeholder.com/350x200';
// Bottom section image - replace with your image URL
const BOTTOM_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/iQhNgMhcbVNSBSXGizynqE/Gerfaj_-_regalo_-_final.png';
// Client logos
const clientLogos = ['https://cdn.magicpatterns.com/uploads/gamcX7xXvBeyaW7HSp8PTA/1.png', 'https://cdn.magicpatterns.com/uploads/8hwitvwsyjDsZV9sFAtxkM/2.png', 'https://cdn.magicpatterns.com/uploads/apeXFDMVBXYpsivry9VsWH/3.png', 'https://cdn.magicpatterns.com/uploads/vVDc9mB3XoJ52qpoXVzNmn/4.png', 'https://cdn.magicpatterns.com/uploads/3s7aAbJ76eEj5Ztq4utsGd/5.png', 'https://cdn.magicpatterns.com/uploads/2iYD4jbL2pr1t9NhoRcJNj/6.png', 'https://cdn.magicpatterns.com/uploads/knLoNmktxSiZkwWMcDEH8a/7.png', 'https://cdn.magicpatterns.com/uploads/ixhd3ktNRnaSwDEo765XEf/8.png', 'https://cdn.magicpatterns.com/uploads/vXuYgGCa2miD3Cwi7n72PL/9.png', 'https://cdn.magicpatterns.com/uploads/bu5xwmVDcWmXxPYF9Tk3wS/10.png'];
const processSteps = [{
  number: '01',
  icon: Eye,
  title: 'Primero revisamos, luego hablamos de plata',
  description: 'Miramos tu espacio a fondo (por videollamada o en persona). Así, el presupuesto que te damos es real y no una cifra inventada que luego se duplica.'
}, {
  number: '02',
  icon: CheckCircle,
  title: '<strong>Tú</strong> decides sin presiones',
  description: 'Te explicamos qué materiales te convienen y cuánto tiempo tomará cada paso. <strong>Tú</strong> decides y apruebas con calma.'
}, {
  number: '03',
  icon: MessageCircle,
  title: 'Nosotros manejamos todo por ti',
  description: 'Estamos presentes en la obra. Resolvemos cualquier detalle y te mantenemos informado por WhatsApp con fotos y avances. <strong>Tú</strong> sigues con tu vida normal.'
}];
export function ProcessSection() {
  const scrollToSituations = () => {
    const situationsSection = document.getElementById('situations');
    situationsSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#1A1A1A] py-12 md:pt-20 pb-0" style={{
    contentVisibility: 'auto'
  }} data-id="element-217">
      <div className="max-w-[1280px] mx-auto px-4" data-id="element-218">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-219">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white mb-3" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-220">
            Nuestro método probado
          </h2>
          <p className="text-[15px] md:text-[17px] text-white/70 max-w-[320px] md:max-w-[280px] mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-221">
            Un método que garantiza resultados, comprobado por más de 30 años.
          </p>
        </div>

        {/* Process Steps */}
        <div className="flex flex-col items-center gap-4 mb-6" data-id="element-222">
          {processSteps.map((step, index) => {
          const Icon = step.icon;
          return <div key={step.number} className="w-full max-w-[380px] bg-white/5 border border-white/10 rounded-[16px] p-6 shadow-[0_2px_12px_rgba(0,0,0,0.3)] animate-fade-in-up" style={{
            animationDelay: `${index * 150}ms`
          }} data-id="element-223">
                {/* Icon */}
                <div className="w-12 h-12 bg-[#E8571A]/20 rounded-[12px] flex items-center justify-center mb-3" data-id="element-224">
                  <Icon className="w-6 h-6 text-[#E8571A]" data-id="element-225" />
                </div>

                {/* Number */}
                <div className="text-[32px] font-bold text-[#E8571A] mb-2" data-id="element-226">
                  {step.number}
                </div>

                {/* Title */}
                <h3 className="text-[20px] md:text-[28px] font-semibold text-white mb-2" style={{
              lineHeight: '1.3'
            }} dangerouslySetInnerHTML={{
              __html: step.title
            }} data-id="element-227" />

                {/* Description */}
                <p className="text-[15px] md:text-[17px] text-white/70 font-normal" style={{
              lineHeight: '1.6'
            }} dangerouslySetInnerHTML={{
              __html: step.description
            }} data-id="element-228" />
              </div>;
        })}
        </div>

        {/* CTA Button - full width on mobile */}
        <div className="flex flex-col items-center mb-8" data-id="element-229">
          <button onClick={scrollToSituations} className="w-full max-w-[380px] bg-[#E8571A] text-white text-[13px] md:text-[15px] font-bold uppercase px-6 md:px-8 py-4 rounded-[12px] flex items-center justify-center gap-2 hover:bg-[#C94A12] transition-colors min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-230">
            <MessageCircle className="w-5 h-5" data-id="element-231" />
            Quiero revisar mi espacio →
          </button>
          <p className="text-[11px] md:text-[12px] text-white/60 mt-2 text-center uppercase font-semibold" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-232">
            Respuesta en menos de 24 horas
          </p>
        </div>

        {/* Bottom Image */}
        <div className="w-full mb-8 -mx-4 md:mx-0" data-id="element-233">
          <img src={BOTTOM_IMAGE_URL} alt="Imagen decorativa" className="w-full h-auto object-cover" width="1280" height="400" loading="lazy" decoding="async" data-id="element-234" />
        </div>

        {/* Logo Carousel */}
        <div className="mb-8 -mx-4 md:mx-0" data-id="element-235">
          <h3 className="text-center text-[20px] md:text-[28px] font-semibold text-white mb-6 px-4 md:px-0" style={{
          lineHeight: '1.3'
        }} data-id="element-236">
            Confiaron en nosotros
          </h3>
          <div className="overflow-x-auto scrollbar-hide" data-id="element-237">
            <div className="flex gap-8 animate-scroll px-4 md:px-0" style={{
            willChange: 'transform'
          }} data-id="element-238">
              {/* Duplicate logos for seamless loop */}
              {[...clientLogos, ...clientLogos].map((logo, index) => <div key={index} className="flex-shrink-0 w-32 h-24 flex items-center justify-center bg-white rounded-lg p-4" data-id="element-239">
                  <img src={logo} alt={`Cliente ${index % clientLogos.length + 1}`} className="w-full h-full object-contain" width="128" height="96" loading="lazy" decoding="async" data-id="element-240" />
                </div>)}
            </div>
          </div>
        </div>

        {/* Gift Card */}
        <div className="flex justify-center" data-id="element-241"></div>
      </div>

      <style jsx data-id="element-242">{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse-border {
          0%,
          100% {
            border-color: #e8571a;
          }
          50% {
            border-color: #f39c6b;
          }
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out forwards;
          opacity: 0;
        }

        .animate-pulse-border {
          animation: pulse-border 2s ease-in-out infinite;
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }

        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
}